import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=f2551a5c&scoped=true"
import script from "./upload-file.vue?vue&type=script&lang=js"
export * from "./upload-file.vue?vue&type=script&lang=js"
import style0 from "./upload-file.vue?vue&type=style&index=0&id=f2551a5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2551a5c",
  null
  
)

export default component.exports